import styled from 'styled-components'

export const PaginationWrap = styled.div`
    display: flex;
    justify-content: center;
    padding: 24px 0 8px;
    border-top: 1px solid #e8edf4;
    margin-top: 16px;
`

export const AlertBanner = styled.div`
    margin-bottom: 12px;
`

export const ToolbarWrap = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-bottom: 16px;
`

export const PageLayout = styled.div`
    display: flex;
    gap: 24px;
    width: 100%;
    flex-wrap: wrap;
`
